import { get_axios_instance, api_variables,errorHandler } from '@/apis/variables.js';

var axios_instance_active_exist_employee = get_axios_instance(api_variables.SERVICE_EMPLOYEE_ACTIVE_EXIST);

//const _pk_name = "id";

const state = {
  data:{},
  exits: {},
  isFetching: false,
  isSaving: false,
  isDeleting: false
};

const mutations = {
  set: (state, payload) => {
    state.data = payload;
    //console.log('fetched data', state.data)
  },
  setExits: (state, payload) => {
    if(payload) {
      state.exits = payload;
    }
    //console.log('fetched exits', state.exits)
  },
  addEmployee: (state, payload) => {
    //console.log('payload data from store', payload)
    state.data = payload;
    //console.log('exit data', state.exits);
    //console.log('state data', state.data);
    // state.data.push(payload);
  },
  setFetching: (state, payload) => {
    state.isFetching = payload;
  },
  setSaving: (state, payload) => {
    state.isSaving = payload;
  },
  setDeleting: (state, payload) => {
    state.isDeleting = payload;
  },
}

const actions = {
  async fetchAll({commit}, payload) {
      //console.log("Employee's List! 2");
      //console.log("Employee's List! ",payload);
    try {
      commit("setFetching", true);
      let res = await axios_instance_active_exist_employee.get(``, {
        params: payload
      });
      commit("setFetching", false);
      //console.log("Employee's List! ", res);
    //   if(res.status == 200) {
    //     commit("set", payload);
    //   }
     commit("set", res.data.rows);
      return res;
    }catch (error){
      //console.log('error', error.response);
      throw errorHandler(error.response);
    }
  },

}

export default {
  namespaced: true,
  state, mutations, actions
}